import { TextVideoMessage } from 'components/Dialogue';
import { MessageExtendComplex } from '../MessageExtend/MessageExtendComplex';
import { BaseMsgProps } from './types';
import { memo, useMemo } from 'react';
import { getMetaFromSender } from '../../utils';

export const TextVideoMsg = memo((props: BaseMsgProps) => {
  const { raw, msg } = props;
  const { sender } = msg;
  const { layout, color } = useMemo(() => getMetaFromSender(sender), [sender]);

  return (
    <MessageExtendComplex
      {...props}
      content={<TextVideoMessage msg={raw} layout={layout} color={color} />}
    />
  );
});
